import { render, staticRenderFns } from "./VisitorCard.vue?vue&type=template&id=196c786e&scoped=true&name=visitorCard&"
import script from "./VisitorCard.vue?vue&type=script&lang=js&"
export * from "./VisitorCard.vue?vue&type=script&lang=js&"
import style0 from "./VisitorCard.vue?vue&type=style&index=0&id=196c786e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c786e",
  null
  
)

export default component.exports